import React, { useState } from 'react';

const NowlunForm = React.createContext();

const NowlunFormProvider = ({ children }) => {
  const [showNowlunForm, setShowNowlunForm] = useState(false);
  const [currentShipment, setCurrentShipment] = useState(null);

  const setShowEditNowlunForm = (shipment) => {
    setShowNowlunForm(true);
    setCurrentShipment(shipment);
  };

  return (
    <NowlunForm.Provider value={{ setShowNowlunForm, setShowEditNowlunForm, showNowlunForm, setCurrentShipment, currentShipment }}>
      {children}
    </NowlunForm.Provider>
  );
};

export { NowlunFormProvider };
export default NowlunForm;
